// TalksPage.jsx
import React from "react";
import EventStats from "../components/Talks/EventStats";
import TalksTimeline from "../components/Talks/TalksTimeline";
import TalksMap from "../components/Talks/TalksMap";
import SEO from "../components/common/SEO";

const TalksPage = () => {
  const talksStructuredData = {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "name": "Speaking Engagements & Conference Talks - Mihir Shah",
    "description": "Conference presentations, keynotes, and speaking engagements by Mihir Shah on cybersecurity, OWASP VXDF, cloud security, and application security topics.",
    "url": "https://mihirshah.tech/talks",
    "mainEntity": {
      "@type": "Person",
      "name": "Mihir Shah",
      "hasOccupation": {
        "@type": "Occupation",
        "name": "Security Engineer & OWASP Project Leader"
      },
      "performerIn": [
        {
          "@type": "Event",
          "name": "Cybersecurity Conference Speaking",
          "description": "Expert presentations on OWASP VXDF, cloud security, and application security"
        },
        {
          "@type": "Event",
          "name": "Industry Keynotes",
          "description": "Keynote presentations on cybersecurity trends and best practices"
        }
      ],
      "knowsAbout": [
        "OWASP VXDF",
        "Cloud Security",
        "Application Security",
        "DevSecOps",
        "Vulnerability Management",
        "Security Architecture"
      ]
    }
  };

  return (
    <>
      <SEO
        title="Speaking Engagements & Conference Talks - Mihir Shah"
        description="Explore Mihir Shah's speaking engagements, conference presentations, and keynotes on cybersecurity topics including OWASP VXDF, cloud security, application security, and DevSecOps at global events."
        keywords="Mihir Shah speaker, cybersecurity conferences, OWASP presentations, cloud security talks, security keynotes, conference speaker, cybersecurity expert speaker, VXDF presentations"
        url="https://mihirshah.tech/talks"
        type="website"
        section="Speaking"
        tags={["Speaking", "Conferences", "Presentations", "Keynotes"]}
        structuredData={talksStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-vxdf-primary to-vxdf-accent bg-clip-text text-transparent">
              Speaking Engagements
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Conference presentations, keynotes, and expert talks on cybersecurity, OWASP VXDF, and emerging security trends
            </p>
          </div>
          
          <EventStats />
          <TalksTimeline />
          <TalksMap />
        </div>
      </div>
    </>
  );
};

export default TalksPage;
